import { Dimensions } from 'react-native'

import CreditCardOutlined from '@zet/design-system/svg/CreditCardOutlined'
import DocumentOutlined from '@zet/design-system/svg/DocumentOutlined'
import MoneyBagOutlined from '@zet/design-system/svg/MoneyBagOutlined'
import UserOutlined from '@zet/design-system/svg/UserOutlined'
import ShoppingBag from '@zet/svg/shoppingBag'

import { IPayoutLog } from '../api/payout/types'
import AddNewMember from '../assets/addNewMember.svg'
import ShareReferralCode from '../assets/shareReferralCode.svg'
import StartEarning from '../assets/startEarning.svg'
import { i18n } from '../localization'

const DEVICE_HEIGHT = Dimensions.get('window').height

const chiperStates = [
  {
    id: 'chip-1',
    title: 'Company',
    iconNameActive: 'CompanyIndustaryFilled',
    iconNameInActive: 'CompanyIndustaryOutlined',
    isActive: true,
  },
  {
    id: 'chip-2',
    title: 'Individual',
    iconNameActive: 'ProfileFilled',
    iconNameInActive: 'ProfileOutlined',
    isActive: false,
  },
]

const tabsData = [
  {
    id: 'chip-1',
    title: i18n.t('dashboardHeader.navigation.dashboard'),
    icon: 'DashboardOutlined',
    isActive: true,
  },
  {
    id: 'chip-2',
    title: i18n.t('dashboardHeader.navigation.leads'),
    icon: 'LeadsOutlined',
    isActive: false,
  },
  {
    id: 'chip-3',
    title: i18n.t('dashboardHeader.navigation.customers'),
    icon: 'UserGroupOutlined',
    isActive: false,
  },
  {
    id: 'chip-4',
    title: i18n.t('dashboardHeader.navigation.myTeams'),
    icon: 'GroupOutlined',
    isActive: false,
  },
]

const AvatartName = [
  { image: '', name: 'Himanshu ' },
  { image: '', name: 'Ankush ' },
  { image: '', name: 'Ankit ' },
  { image: '', name: 'Srikanth ' },
  { image: '', name: 'Himanshu ' },
  { image: '', name: 'Ankush ' },
  { image: '', name: 'Ankit ' },
]

const enum LeadStatus {
  LEAD_ADDED = 'leadadded',
  ACTION_REQUIRED = 'actnreqrd',
  PARTIALLY_FULLFILLED = 'pfulfilled',
  FULLFILLED = 'fullfilled',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
  INCOMPLETE = 'saleIncomplete',
}

const enum PaymentStatus {
  PENDING = 'pending',
  PAID = 'paid',
  REJECTED = 'rejected',
  FAILED = 'failed',
}

const QuickFilter = {
  stage: {
    name: 'stage',
    value: [],
  },
  brands: {
    name: 'partner',
    value: [] as string[],
  },
  profileStatus: {
    name: 'status',
    value: [] as string[],
  },
  category: {
    name: 'category',
    value: [] as string[],
  },
}

const PAN_ERROR_CODE = [2008, 2015, 3311]
const APP_URL = 'https://play.google.com/store/apps/details?id=in.myteams.app'

const COMPANY = 'COMPANY'

const setIntent = (
  status: string,
  hasNotMoved: boolean
): 'warning' | 'active' | 'error' | 'success' | undefined => {
  switch (status) {
    case LeadStatus.LEAD_ADDED:
    case LeadStatus.ACTION_REQUIRED:
      return hasNotMoved ? 'warning' : 'active'
    case LeadStatus.FULLFILLED:
    case LeadStatus.PARTIALLY_FULLFILLED:
      return 'success'
    case LeadStatus.EXPIRED:
    case LeadStatus.REJECTED:
      return 'error'

    default:
      return undefined
  }
}

const renderStepperImage = (step: string) => {
  if (step === 'step1') {
    return <ShareReferralCode />
  } else if (step === 'step2') {
    return <AddNewMember />
  } else if (step === 'step3') {
    return <StartEarning />
  }
}
const getPercentage = (value: number, total: number) => {
  return Math.round((value / 100) * total)
}

const getPayoutLogDetails = (item: IPayoutLog) => {
  const {
    teamId,
    categoryId,
    partnerId,
    isPayoutOverrideForAll,
    partnerName,
    teamName,
    teamPhoneNumber,
    categoryIdForTheIcon,
  } = item

  if (!teamId && categoryId) {
    return {
      icon: <DocumentOutlined />,
      title: 'Payout Plan Changed',
      subTitle: getCategoryName(categoryId),
      assignedTo: isPayoutOverrideForAll
        ? 'All Team members'
        : 'All except Custom Payout Assignee',
    }
  }

  if (partnerId && !teamId) {
    return {
      icon: getCategoryIcon(categoryIdForTheIcon),
      title: 'Custom Payout Assigned to Brand',
      subTitle: partnerName,
      assignedTo: isPayoutOverrideForAll
        ? 'All Team members'
        : 'All except Custom Payout Assignee',
    }
  }

  if (teamId && (partnerId || categoryId)) {
    const subTitle = partnerId ? partnerName : getCategoryName(categoryId)
    const assignedTo = partnerId
      ? `${teamName} (${teamPhoneNumber})`
      : `${teamName} (${teamPhoneNumber})`

    return {
      icon: <UserOutlined />,
      title: 'Custom Payout Assigned to Agent',
      subTitle,
      assignedTo,
    }
  }

  return undefined
}

const getCategoryName = (id: number | string) => {
  switch (id?.toString()) {
    case '15':
      return 'All Credit Card Brands'
    case '9':
      return 'All Personal Loan Brands'
    case '18':
      return 'All Secured Card Brands'
    case '10':
      return 'All Business Loan Brands'
    case '11':
      return 'All Instant Loan Brands'
    case '16':
      return 'All Pay Later/EMI Card Brands'
    case '12':
      return 'All Gold Loan Brands'
    case '2':
      return 'All Digital Gold Brands'
    case '5':
      return 'All Bank Accounts'
    case '17':
      return 'All Other Brands'
    case '14':
      return 'All Insurance Brands'
    case '1':
      return 'All Investment Brands'
    case '3':
      return 'All Payment Gateway'
    case '4':
      return 'All Fastag'
    case '6':
      return 'All Demat Accounts'
    case '7':
      return 'All Cryptocurrency'
    case '8':
      return 'All Recharge & Bill Payments'
    default:
      return ''
  }
}

const getCategoryIcon = (id: number | string) => {
  switch (id?.toString()) {
    case '15':
      return <CreditCardOutlined />
    case '9':
      return <MoneyBagOutlined />
    case '18':
      return <CreditCardOutlined />
    case '10':
      return <MoneyBagOutlined />
    case '11':
      return <MoneyBagOutlined />
    case '16':
      return <ShoppingBag />
    case '12':
      return <MoneyBagOutlined />
    case '2':
      return <ShoppingBag />
    case '5':
      return <ShoppingBag />
    case '17':
      return <ShoppingBag />
    case '14':
      return <MoneyBagOutlined />
    default:
      return <MoneyBagOutlined />
  }
}

const teamEarningsFilterTypes = {
  TEAM_FILTER: 'isTeamFilter',
  BRAND_FILTER: 'isBrandFilter',
  STATUS_FILTER: 'isStatusFilter',
}

type TeamEarningsFiltersType = {
  label: string
  icon: string
  type: 'isTeamFilter' | 'isBrandFilter' | 'isStatusFilter'
  name: 'teams' | 'brands' | 'paymentStatus'
  width: number
}

const teamEarningsFilters = [
  {
    label: 'Advisor',
    icon: 'UserGroupOutlined',
    type: teamEarningsFilterTypes.TEAM_FILTER,
    name: 'teams',
    width: 240,
  },
  {
    label: 'Brands',
    icon: 'TagOutlined',
    type: teamEarningsFilterTypes.BRAND_FILTER,
    name: 'brands',
    width: 280,
  },
  {
    label: 'Status',
    icon: 'MoreOutlined',
    type: teamEarningsFilterTypes.STATUS_FILTER,
    name: 'paymentStatus',
    width: 180,
  },
] as TeamEarningsFiltersType[]

function truncateString(str: string, maxLength = 20) {
  return str.length <= maxLength ? str : str.slice(0, maxLength) + '...'
}

export {
  APP_URL,
  AvatartName,
  COMPANY,
  LeadStatus,
  PAN_ERROR_CODE,
  PaymentStatus,
  QuickFilter,
  chiperStates,
  getCategoryName,
  getPayoutLogDetails,
  getPercentage,
  renderStepperImage,
  setIntent,
  tabsData,
  teamEarningsFilterTypes,
  teamEarningsFilters,
  truncateString,
}
